import React from 'react'
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './Home';
import Navbar from './Navbar';
import Footer from './Footer';
import About from './About';
import Menu from './Menu';
import Contact from './Contact';
import Singin from './Signin';
import Book from './Booktable';
import ScrollToTop from './ScrollToTop';
import Dashboard from './Dashboard';

const AppContent = () => {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';

  return (
    <div className='app'>
      <ScrollToTop />
      {!isDashboard && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/signin" element={<Singin />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/book-a-table" element={<Book />} />
      </Routes>
      {!isDashboard && <Footer />}
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App
